import { useEffect, useState } from "react";

/** LOT 47 — Renvoie une version différée de `value` (par défaut 500 ms).
 *  Utilisé pour ne recalculer les vues lourdes (graphique trésorerie, tableau
 *  prévisionnel N mois) qu'une fois la frappe terminée, jamais à chaque touche. */
export default function useDebouncedValue(value, delay = 500) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(t);
    }, [value, delay]);
    return debounced;
}
